import { render } from "./Voor.vue?vue&type=template&id=678ff2f5&ts=true"
import script from "./Voor.vue?vue&type=script&lang=ts"
export * from "./Voor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__